import { resolveId } from '@medplum/core'
import type { Patient, Reference } from '@medplum/fhirtypes'
import { Participant } from '@seen/core/models/patients/participant'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { ParticipantNameplate } from '#src/components/nameplates/ParticipantNameplate.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { useReference } from '#src/hooks/useReference.ts'

export function ParticipantNameplateLink({
  participant,
}: {
  participant: Reference<Patient> | string
}): JSX.Element {
  const participantReference = useReference(participant)
  const { data: instance } = useRead(Participant, participantReference)
  return (
    <Link
      to={
        instance?.relativeUrl ?? `/Patient/${resolveId(participantReference)}`
      }
      className="decoration-1 underline-offset-[2.5px] hover:underline"
    >
      <ParticipantNameplate participant={participant} />
    </Link>
  )
}
